import { type Framework, GlobalCache, GlobalState } from '@toeverything/infra';

import { IndexedDBGlobalCache, IndexedDBGlobalState } from './impls/indexeddb';
import {
  LocalStorageGlobalCache,
  LocalStorageGlobalState,
} from './impls/local-storage';

export function configureLocalStorageStateStorageImpls(framework: Framework) {
  framework.impl(GlobalCache, LocalStorageGlobalCache);
  framework.impl(GlobalState, LocalStorageGlobalState);
}

export function configureIndexedDBStateStorageImpls(framework: Framework) {
  framework.impl(GlobalCache, IndexedDBGlobalCache);
  framework.impl(GlobalState, IndexedDBGlobalState);
}

// Export the IndexedDB implementations as the default storage
export { IndexedDBGlobalCache, IndexedDBGlobalState };
